module.exports = __webpack_public_path__ + "img/chilo-sacchariphagus.d7afe7ca.jpg";